var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9005 14.859L11.9959 11.9544C13.079 10.74 13.7518 9.1318 13.7518 7.3759C13.7518 3.58513 10.6667 0.5 6.8759 0.5C3.08513 0.5 0 3.58513 0 7.3759C0 11.1667 3.08513 14.2518 6.8759 14.2518C8.22154 14.2518 9.46872 13.8579 10.519 13.2015L13.5385 16.221C13.719 16.4015 13.9651 16.5 14.2113 16.5C14.4574 16.5 14.7036 16.4015 14.8841 16.221C15.2779 15.8436 15.2779 15.2364 14.9005 14.859ZM1.92 7.3759C1.92 4.6518 4.13538 2.42 6.8759 2.42C9.61641 2.42 11.8154 4.6518 11.8154 7.3759C11.8154 10.1 9.6 12.3318 6.8759 12.3318C4.15179 12.3318 1.92 10.1164 1.92 7.3759Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e8bcbab2ce8734cd1f73b58673bb68d4.svg";
export { ForwardRef as ReactComponent };